import { render, staticRenderFns } from "./servicoCorreio.vue?vue&type=template&id=553bb9a8"
import script from "./servicoCorreio.ts?vue&type=script&lang=js&external"
export * from "./servicoCorreio.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553bb9a8')) {
      api.createRecord('553bb9a8', component.options)
    } else {
      api.reload('553bb9a8', component.options)
    }
    module.hot.accept("./servicoCorreio.vue?vue&type=template&id=553bb9a8", function () {
      api.rerender('553bb9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/etiquetas/servicoCorreio.vue"
export default component.exports